import { useState, useEffect } from 'react';
import logo from '../assets/logo2.jpg';

export default function Header({ t, lang, toggleLang }) {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);
  let lastScroll = 0;

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;
      
      // Проверяем ширину экрана — скрываем только на десктопе (≥1024px)
      const isDesktop = window.innerWidth >= 1024;
      
      if (isDesktop && currentScroll > lastScroll && currentScroll > 100) {
        setHidden(true);
      } else {
        setHidden(false);
      }
      
      setScrolled(currentScroll > 20);
      lastScroll = currentScroll;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const languages = [
    { code: 'RU', label: 'Русский', short: 'RU' },
    { code: 'ENG', label: 'English', short: 'EN' },
    { code: 'ARM', label: 'Հայերեն', short: 'AM' }
  ];

  const handleLangChange = (code) => {
    toggleLang(code);
    setIsOpen(false);
  };

  const navItems = [
    { href: '#home', label: t.homeLink },
    { href: '#about', label: t.aboutTitle },
    { href: '#challenges', label: t.challengesTitle || t.problemsTitle },
    { href: '#solutions-page', label: t.solutionsTitle },
    { href: '#industries', label: t.industriesTitle },
    { href: '#partners', label: t.partnersPageTitle },
    { href: '#projects', label: t.projectsTitle },
    { href: '#blog', label: t.newsTitle || t.blogTitle },
    { href: '#contact', label: t.contactTitle }
  ];

  const socialLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/share/1Fzs4GyAxY/',
      icon: (
        <svg width="27" height="27" viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      )
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/nwt.am?igsh=MTQwcjdiYzM1MXU0aQ==',
      icon: (
        <svg width="27" height="27" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
        </svg>
      )
    },
    {
      name: 'YouTube',
      url: 'https://youtube.com/@nationalwatertechnologyarmenia?si=RY4lHcbUdkjoPqwr',
      icon: (
        <svg width="27" height="27" viewBox="0 0 24 24" fill="currentColor">
          <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      )
    }
  ];

  return (
    <div className={`fixed top-0 w-full left-0 flex justify-center pt-4 items-center z-50 px-4 transition-all duration-500 ${
      hidden ? '-translate-y-[120%] opacity-0' : 'translate-y-0 opacity-100'
    }`}>
      <header className={`w-full lg:w-max z-50 backdrop-blur-sm relative transition-all duration-500 border-2 ${
        scrolled 
          ? 'bg-white shadow-lg' 
          : 'bg-white border-gray-200'
      }`}>
        
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className={`absolute top-0 left-0 h-[2px] bg-gradient-to-r from-transparent via-[#0FA4E8] to-transparent transition-all duration-1000 ${
            scrolled ? 'w-full' : 'w-0'
          }`} />
          <div className={`absolute bottom-0 right-0 h-[2px] bg-gradient-to-l from-transparent via-[#0FA4E8] to-transparent transition-all duration-1000 delay-300 ${
            scrolled ? 'w-full' : 'w-0'
          }`} />
        </div>

        <div className="mx-auto flex w-full items-center justify-between gap-6 px-3 py-3 md:px-6">
          
          <a href="#home" className="flex-shrink-0">
            <img src={logo} alt="NWTA" className="w-36 md:w-40 h-8 md:h-10 object-cover" />
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="relative group uppercase text-xs font-bold text-[#0B3B6F] hover:text-[#0FA4E8] transition-colors duration-300 px-3 py-1"
              >
                {item.label}
                <span className="absolute bottom-0 left-3 right-3 h-0.5 bg-[#0FA4E8] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2 flex-shrink-0">
            
            <div className="relative group hidden sm:block">
              <button className="flex items-center gap-1.5 border-2 border-gray-200 bg-white px-3 py-2 text-xs font-bold uppercase tracking-wider text-[#0B3B6F] hover:border-[#0FA4E8] hover:text-[#0FA4E8] transition-all duration-300">
                <span>{languages.find(l => l.code === lang)?.short || lang}</span>
                <svg className="w-3 h-3 transition-transform duration-300 group-hover:rotate-180" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M6 9l6 6 6-6"/>
                </svg>
              </button>

              <div className="absolute right-0 top-full pt-1 w-36 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 translate-y-1 group-hover:translate-y-0 z-50">
                <div className="bg-white border border-gray-200 shadow-lg flex flex-col overflow-hidden">
                  {languages.map((l) => (
                    <button
                      key={l.code}
                      onClick={() => handleLangChange(l.code)}
                      className={`text-left px-4 py-2.5 text-xs font-bold uppercase transition-all flex items-center justify-between ${
                        lang === l.code 
                          ? 'bg-[#0FA4E8] text-white' 
                          : 'text-[#0B3B6F] hover:bg-gray-50 hover:text-[#0FA4E8]'
                      }`}
                    >
                      <span>{l.label}</span>
                      <span className="text-[10px] opacity-50">{l.short}</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <button
              onClick={() => setIsOpen(!isOpen)}
              className="relative flex h-10 w-10 flex-col items-center justify-center gap-1.5 border-2 border-gray-200 bg-white text-[#0B3B6F] hover:border-[#0FA4E8] hover:text-[#0FA4E8] transition-all duration-300 lg:hidden"
              aria-label="Toggle menu"
            >
              <span className={`h-0.5 w-5 bg-current transition-all duration-300 ${isOpen ? 'translate-y-[7px] rotate-45' : ''}`} />
              <span className={`h-0.5 w-5 bg-current transition-all duration-300 ${isOpen ? 'opacity-0' : ''}`} />
              <span className={`h-0.5 w-5 bg-current transition-all duration-300 ${isOpen ? '-translate-y-[9px] -rotate-45' : ''}`} />
            </button>
          </div>
        </div>

        {/* Мобильное меню со скроллом */}
        <div className={`transition-all duration-300 overflow-hidden ${isOpen ? 'max-h-[80vh] opacity-100' : 'max-h-0 opacity-0'}`}>
          <div className="border-t border-gray-200 bg-white lg:hidden">
            <div className="overflow-y-auto max-h-[80vh] px-6 py-6">
              
              <div className="flex gap-2 mb-6 pb-4 border-b border-gray-100">
                {languages.map((l) => (
                  <button
                    key={l.code}
                    onClick={() => handleLangChange(l.code)}
                    className={`px-3 py-1.5 text-xs font-bold uppercase border transition-all ${
                      lang === l.code
                        ? 'bg-[#0FA4E8] text-white border-[#0FA4E8]'
                        : 'text-[#0B3B6F] border-gray-200 hover:border-[#0FA4E8]'
                    }`}
                  >
                    {l.short}
                  </button>
                ))}
              </div>

              <nav className="flex flex-col gap-1">
                {navItems.map((item, idx) => (
                  <a
                    key={item.href}
                    href={item.href}
                    onClick={() => setIsOpen(false)}
                    className="text-sm font-bold text-[#0B3B6F] hover:text-[#0FA4E8] transition-colors duration-300 py-2.5 border-b border-gray-50 flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 bg-[#0FA4E8] rounded-full opacity-0 group-hover:opacity-100 transition-opacity" />
                    {item.label}
                  </a>
                ))}
              </nav>

              {/* Соцсети в мобильном меню */}
              <div className="mt-6 pt-4 border-t border-gray-100">
                <p className="text-xs font-bold text-[#0B3B6F] uppercase tracking-wider mb-3">
                  {t.socialTitle || 'Social links'}
                </p>
                <div className="flex items-center gap-3">
                  {socialLinks.map((social) => (
                    <a
                      key={social.name}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center rounded-none justify-center w-10 h-10 border border-gray-200 text-[#0B3B6F] hover:bg-[#0FA4E8] hover:text-white hover:border-[#0FA4E8] transition-all duration-300"
                      aria-label={social.name}
                    >
                      {social.icon}
                    </a>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </div>

      </header>
    </div>
  );
}